const Login = [
  {
    path: '/Login/:ts?',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../../views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/Register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "login" */ '../../views/login/register.vue'),
    meta: { title: '注册' }
  },
  {
    path: '/switch',
    name: 'switch',
    component: () => import(/* webpackChunkName: "login" */ '../../views/login/switch.vue'),
    meta: { title: '选择账号' }
  },
  {
    path: '/ForgetPasswordShow',
    name: 'ForgetPasswordShow',
    component: () => import(/* webpackChunkName: "login" */ '../../views/login/ForgetPasswordShow.vue'),
    meta: { title: '找回密码', showBackBtn: true }
  },
  {
    path: '/getOpenId',
    name: 'getOpenId',
    component: () => import(/* webpackChunkName: "login" */ '../../views/login/getOpenId.vue'),
    meta: { title: '微信授权', showBackBtn: true }
  }
]

export default Login
